namespace GeniuzPOS.Administration {
    export interface PsFuncKbMapKeyCodeForm {
        KbMapKeyCode: Serenity.IntegerEditor;
        KbMapKeyName: Serenity.StringEditor;
    }

    export class PsFuncKbMapKeyCodeForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.PsFuncKbMapKeyCode';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsFuncKbMapKeyCodeForm.init)  {
                PsFuncKbMapKeyCodeForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(PsFuncKbMapKeyCodeForm, [
                    'KbMapKeyCode', w0,
                    'KbMapKeyName', w1
                ]);
            }
        }
    }
}
